const languages = ['it', 'en']

export default languages